<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;width: 100%">
    <div id="mainContentWrapper"
         style="width: 100%;min-width:1000px;display: flex;flex-direction: column;align-items: center;justify-content: flex-start"
         bgScroll="none">
      <Header/>
      <Banner/>
      <div class="title-con">
        <div class="w-line"/>
        <div v-if="this.$route.name === 'products'" class="title-con-right">
          <div style="font-size:24px;margin-top: 10px;">产品中心</div>
          <div style="line-height:31px;font-size: large">Contact Us</div>
        </div>
        <div v-else class="title-con-right">
          <div style="font-size:24px;margin-top: 10px;">产品优势</div>
          <div style="line-height:31px;font-size: large">Advantages</div>
        </div>
      </div>
      <div v-if="this.$route.name === 'products'" class="cell-row">
        <li class="w-list-item f-clearfix" v-for="(item, index) in dataList" :key="index">
          <a :href="item.id" target="_self" class="w-list-link">
            <div class="w-list-pic" style="height: 220px;">
              <img :alt="item.title" :src="item.img" class="w-listpic-in"
                   autofill="ok" init="ok" style="width: auto; height: 220px; margin-left: -1.25px;">
            </div>
            <div class="w-list-bottom">
              <h5 class="w-list-title" style="height: 28px;">{{ item.title }}</h5>
              <div class="w-list-desc " style="height: 20px;">
                {{ item.intro }}
              </div>
            </div>
          </a>
        </li>
      </div>
      <div v-else class="cell-row">
        <li class="w-al-unit" v-for="(item, index) in dataList1" :key="index">
          <a :href="item.id" target="_self">
            <div class="w-al-pic">
              <img :alt="item.title" :src="item.img" autofill="ok" init="ok"
                   style="width: 220px; height: 160px;">
            </div>
            <div class="w-al-text" style="height: 34px;">
              <h5 class="w-al-title" style="padding-top: 0px;">{{ item.title }}</h5>
              <p class="w-al-desc"></p>
            </div>
          </a>
        </li>
      </div>
      <PageFen :currentPage="pageNow" :showItemPerPage="4" :totalPage="pageTotal" :callBack="_pageChange"
               style="margin-top: 30px;"/>

    </div>

    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Banner from "@/components/Banner";
import Footer from "@/components/Footer";
import PageFen from "@/components/PageFen";

export default {
  name: 'DetailPageList',
  components: {
    PageFen,
    Footer,
    Banner,
    Header
  },
  methods: {
    _pageChange(e) {
      console.log(e)
    }
  },
  data() {
    return {
      pageNow: 1,
      pageTotal: 1,
      dataList1: [
        {
          id: '/#/detail?id=5',
          title: '克罗兔ClO₂——竞争优势',
          img: '../../img/29923457.jpg'
        },
        {
          id: '/#/detail?id=6',
          title: '克罗兔ClO₂——国际认证',
          img: '../../img/29921552.jpg'
        },
        {
          id: '/#/detail?id=7',
          title: '克罗兔ClO₂——权威检测',
          img: '../../img/29921550.jpg'
        },
        {
          id: '/#/detail?id=8',
          title: '克罗兔ClO₂——技术创新点',
          img: '../../img/29921539.jpg'
        }
      ],
      dataList: [
        {
          id: '/#/detail?id=1',
          title: '克罗兔纳米雾化杯',
          img: '../../img/29947401.jpg',
          intro: '克罗兔纳米雾化杯是一款小巧便携的纳米雾化杯，须与克罗兔空气雾化消毒片（0.5g装）搭配使用。甜筒采用先进的纳米雾化技术，雾量大、雾化效果好，并在极短时间内通过出雾口均匀地将雾气扩散到空气中，有效灭杀空气中的病毒、细菌，去除甲醛，净化室内空气，净享健康呼吸。'
        },
        {
          id: '/#/detail?id=2',
          title: '克罗兔纳米雾化器',
          img: '../../img/29946868.jpg',
          intro: '克罗兔纳米雾化器采用纳米雾化技术，可通过先进的雾化装置及高强力的输送系统将液体以纯分子态快速释放到空气中。初见须与克罗兔空气雾化消毒片（1.0g装）搭配使用，可将消毒片完全溶解后的消毒液雾化为微纳米级的液滴，并在极短的时间内通过出雾口均匀地将雾气扩散到空气中，高效灭杀空气中的病毒、细菌，去除甲醛，实现360°的室内防护，净享健康呼吸。'
        },
        {
          id: '/#/detail?id=3',
          title: '克罗兔空气雾化消毒片（1g装）',
          img: '../../img/28041944.png',
          intro: '克罗兔空气雾化消毒片是以ClO₂为主要成分的消毒泡腾片，可快速溶于水，制成消毒液。本品与克罗兔纳米雾化器搭配使用，可将消毒液雾化为微纳米级液滴并快速扩散，有效杀灭空气中的病毒、细菌，去除甲醛，净化空气。'
        },
        {
          id: '/#/detail?id=4',
          title: '克罗兔空气雾化消毒片（0.5g装）',
          img: '../../img/28041942.png',
          intro: '克罗兔空气雾化消毒片是以ClO₂为主要成分的消毒产品，可快速溶于水，制成消毒液。本品（0.5g装）与克罗兔纳米雾化杯搭配使用，可将消毒液雾化为微纳米级的液滴并快速扩散，有效杀灭空气中的病毒、细菌，去除甲醛，净化空气。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.cell-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.title-con {
  width: 1000px;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 30px 0 0 0;
  margin-bottom: 30px;
}

.title-con .title-con-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 20px;
}

.w-line {
  display: block;
  margin: 0;
  margin-left: -3px;
  padding: 0;
  width: 1px;
  height: 64px;
  font-size: 0;
  border-left-width: 6px;
  border-left-style: solid;
  border-left-color: #444444;
  -moz-box-shadow: 0 0 0 transparent;
  -webkit-box-shadow: 0 0 0 transparent;
  -ms-box-shadow: 0 0 0 transparent;
  -o-box-shadow: 0 0 0 transparent;
  box-shadow: 0 0 0 transparent;
}

.w-al-unit {
  padding: 0;
  width: 220px;
  min-width: 100px;
  margin: 0 0 8px 8px;
  overflow: hidden;
  display: inline-block;
  float: left;
  position: relative;
  list-style: none;
  cursor: pointer;
}

.w-al-unit a {
  width: 100%;
  display: block;
  text-decoration: none;
  text-align: center;
}

.w-al-pic {
  width: 220px;
  min-width: 100px;
  height: 160px;
  line-height: 160px;
  padding: 0;
  vertical-align: top;
  clear: both;
  overflow: hidden;
}

.w-al-text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding: 0 8px;
  background-color: rgba(0, 0, 0, 0.6);
  background-image: none;
  background-repeat: repeat;
  background-position: 0 0;
  background: -moz-linear-gradient(top, none, none);
  background: -o-linear-gradient(top, none, none);
  background: linear-gradient(top, none, none);
  background: -webkit-gradient(linear, left top, left bottom, from(none), to(none));
  box-sizing: border-box;
}

.w-al-title {
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #fff;
  text-align: left;
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
  font-family: Tahoma;
  line-height: 34px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  overflow: hidden;
}

img {
  width: 220px;
  min-width: 100px;
  height: 160px;
  object-fit: cover;
  border: none;
  -webkit-transition: transform .3s ease;
  -moz-transition: transform .3s ease;
  -o-transition: transform .3s ease;
  -ms-transition: transform .3s ease;
  transition: transform .3s ease;
}

.w-list-item {
  padding: 0;
  margin: 0;
  margin-left: 15px;
  margin-bottom: 15px;
  display: inline-block;
  float: left;
  width: 236px;
  min-width: 100px;
  overflow: hidden;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  background-color: #fff;
  background-image: none;
  background-repeat: repeat;
  background-position: 0 0;
  background: -moz-linear-gradient(top, none, none);
  background: -o-linear-gradient(top, none, none);
  background: linear-gradient(top, none, none);
  background: -webkit-gradient(linear, left top, left bottom, from(none), to(none));
  border-top-width: 1px;
  border-top-color: #f5f5f5;
  border-top-style: solid;
  border-bottom-color: #f5f5f5;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-right-width: 1px;
  border-right-color: #f5f5f5;
  border-right-style: solid;
  border-left-color: #f5f5f5;
  border-left-style: solid;
  border-left-width: 1px;
  list-style: none;
  -webkit-transition: all 200ms linear;
  -moz-transition: all 200ms linear;
  -o-transition: all 200ms linear;
  -ms-transition: all 200ms linear;
  transition: all 200ms linear;
}

.w-list-link {
  width: 100%;
  height: 100%;
  display: block;
  border-top-left-radius: 0;
  -webkit-border-top-left-radius: 0;
  -moz-border-top-left-radius: 0;
  border-top-right-radius: 0;
  -webkit-border-top-right-radius: 0;
  -moz-border-top-right-radius: 0;
  text-decoration: none;
  outline: none;
}

.w-list-bottom {
  padding: 0 10px 10px 10px;
  margin: 0;
}

.w-list-desc {
  height: 20px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 12px;
  color: #999;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  font-family: 'Microsoft YaHei';
}
</style>